import { ExchangeCode } from "@/lib/market-data/market-data.types";
import { ExchangeCandleWsAdapter } from "../../candle.types";
import {
  binanceCandlesWsAdapter,
  createFuturesKlineWsAdapter,
} from "./binance-candles.ws";
import { bybitCandlesWsAdapter } from "./bybit-candles.ws";
import { hyperliquidCandlesWsAdapter } from "./hyperliquid-candles.ws";
import { noopCandlesWsAdapter } from "./noop-candles.ws";

export const CANDLE_WS_ADAPTERS: Record<ExchangeCode, ExchangeCandleWsAdapter> = {
  binance: binanceCandlesWsAdapter,
  bybit: bybitCandlesWsAdapter,
  gate: noopCandlesWsAdapter,
  kucoin: noopCandlesWsAdapter,
  hyperliquid: hyperliquidCandlesWsAdapter,
  asterdex: createFuturesKlineWsAdapter(
    "asterdex",
    (stream) => `wss://fstream.asterdex.com/ws/${stream}`
  ),
};
